import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import * as roleActions from './roles-arcgis.actions';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService } from '../../../../../core/services';
import { AUTH_ACCESS_TOKEN, NotificationService } from '../../../../../core';
import { RolArcgisService } from 'src/app/core/services';
import { ConfigService } from '../../../../../shared/services';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class RolesArcgisEffects {
  RolesArcgisLoadRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<roleActions.RolesArcgisLoadRequestAction>(
        roleActions.RolesArcgisActionTypes.LOAD_REQUEST
      ),
      switchMap((action) => {
        const tokenSistema = ConfigService.config.tokenSistema;
        const token = this.localStorageService.getItem(AUTH_ACCESS_TOKEN);
        return this.rolService.getRoles(tokenSistema, token).pipe(
          map((response) => {
            if (response) {
              if (response.roles) {
                return new roleActions.RolesArcgisLoadSuccessAction({
                  items: response.roles,
                });
              }
              return new roleActions.RolesArcgisLoadFailureAction({
                error: 'Si es Productor o Propietario debe dar de alta Empresa',
              });
            }
            console.log(response);
            return new roleActions.RolesArcgisLoadSuccessAction({
              items: []
            });
          }),
          catchError((error: HttpErrorResponse) =>
            observableOf(
              new roleActions.RolesArcgisLoadFailureAction({
                error: error.error,
              })
            )
          )
        );
      })
    )
  );

  // fail
  RolesArcgisFailureEffect$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(roleActions.RolesArcgisActionTypes.LOAD_FAILURE),
        map((action: roleActions.RolesArcgisLoadFailureAction) => action.payload.error),
        tap((error: string) => {
          if(error)
          return this.notificationService.error(error);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private rolService: RolArcgisService,
    private actions$: Actions,
    @Inject(DOCUMENT) readonly document: Document,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService
  ) {}
}
